// extracted by mini-css-extract-plugin
export default {"menuBody":"Menuoption_menuBody__pJmDH","menuIcon":"Menuoption_menuIcon__Ux97K","menuContent":"Menuoption_menuContent__42Kme"};